import React from "react"
import { Link } from "gatsby"
import navStyles from "./nav.module.scss"

const Header = () => {
    return (       
        <nav>
            <div className = {navStyles.title}>Mark Webster</div>
            <Link className ={navStyles.navItem} activeClassName={ navStyles.activeNavitem} to ="/">Home</Link> |
            <Link className ={navStyles.navItem} activeClassName={ navStyles.activeNavitem} to ="/about"> About</Link> |
            <Link className ={navStyles.navItem} activeClassName={ navStyles.activeNavitem} to ="/process"> Process</Link> |
            {/*|
            <Link className ={navStyles.navItem} activeClassName={ navStyles.activeNavitem} to ="/gallery"> Images</Link> */}
           
          <Link className ={navStyles.navItem} activeClassName={ navStyles.activeNavitem} to ="/blog"> Blog</Link> 
        </nav>
    )
}

export default Header

